import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

import TextField from '@mui/material/TextField';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
// import { useStoreId } from './StoreProviders';

// ----------------------------------------------------------------------

PostSearch.propTypes = {
  posts: PropTypes.array.isRequired,
  storeId: PropTypes.number,
  size: PropTypes.string,
  sx: PropTypes.object,
  search: PropTypes.object,
};

const CustomAutocomplete = styled(Autocomplete)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    color: '#333333', // Set the label color to purple (hex format)
  },
  '& .MuiOutlinedInput-input': {
    color: '#333333', // Set the text color to purple (hex format)
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '0.6rem',
    borderColor: '#E5E8EC',
    // borderColor: '#333333',
    // Set the border color to purple (hex format)
  },
}));

export default function PostSearch({ posts, size, sx, search, onUpdateStoreId }) {
  // const { dispatch } = useStoreId();
  const [selectedOption, setSelectedOption] = useState({ Option: 'ALL', id: 0 }); // State to store the selected option
  const handleOptionChange = (event, value) => {
    setSelectedOption(value);
    console.log(value);
    if (value === 0) {
      onUpdateStoreId(0);
    } else {
      onUpdateStoreId(value.id);
    }

    console.log(value); // Update the selected option in the state
  };
  useEffect(() => {
    // if (!selectedOption) setSelectedOption({ Option: "ALL", id: 0 });
    if (!selectedOption) {
      onUpdateStoreId(0);
    } else onUpdateStoreId(selectedOption.id);
  }, [selectedOption]);

  const CheckOption = () => {
    if (!selectedOption) {
      setSelectedOption({ Option: 'ALL', id: 0 });
    }
  };
  const handleClear = (e) => {
    setSelectedOption({ Option: null, id: null });
  };
  return (
    <ThemeProvider theme={createTheme({ palette: { primary: { main: '#333333' } } })}>
      <CustomAutocomplete
        sx={{ width: 280, color: 'purple', ...sx }}
        autoHighlight
        // value={posts}
        // popupIcon={null}
        onChange={handleOptionChange}
        size="small"
        onBlur={CheckOption}
        value={selectedOption}
        // onClear={handleClear}
        slotProps={{
          textField: { size: 'small' },
          paper: {
            sx: {
              width: 320,
              [`& .${autocompleteClasses.option}`]: {
                typography: 'body2',
              },
              ...sx,
            },
          },
        }}
        options={posts}
        getOptionLabel={(post) => post?.Option}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField
            {...params}
            size={'small'}
            sx={{
              ...sx,
            }}
            label="Store Id"
            placeholder="Search post..."
            InputProps={{
              ...params.InputProps,
              // startAdornment: (
              //   <InputAdornment position="start">
              //     <Iconify
              //       icon="eva:search-fill"
              //       sx={{ ml: 1, width: 20, height: 20, color: 'text.disabled', ...search }}
              //     />
              //   </InputAdornment>
              // ),
            }}
          />
        )}
      />
    </ThemeProvider>
  );
}
